import 'css-chunk:src/index/components/task_detail/index.module.scss';export default {
  "container": "container__ujtLk",
  "sections": "sections__I6Uay",
  "modalContent": "modalContent__XgfTy",
  "row": "row__gb-3I",
  "item": "item__QKJ7B",
  "description": "description__liT9L",
  "detail": "detail__V3zyp",
  "footer": "footer__wb9zN"
};